import util from '../../../common/util';

// form  Parent element for all forms ， Right now $('.cal-container form')[0]
function calculateResult(data) {
    var resultObj = {};
    // data for input  all in the box value the value of 
    for (var key in data) {
        if (util.isString(data[key])) {
            data[key] = parseFloat(data[key].replace(/,/g, ''));
        }
    }
    //  monthly interest rate 
    var monthlyInterestRate = data.interestRate / 1200; //l
    //  total loan interest rate  = （1+l）^( total number of months )
    var totalLoanInterestRate = Math.pow(
        1 + monthlyInterestRate,
        data.loanTerm * 12
    ); //0
    //  total loan amount 
    // let paymentValue = data.homePrice * data.downPayment /100;
    var totalLoanAmount =
        data.downPaymentRatio == 0 && data.total
            ? data.total
            : data.downPaymentValue *
            ((1 - data.downPaymentRatio / 100) /
                (data.downPaymentRatio / 100)); //e
    //  monthly bank loan repayment 
    var resultPI =
        (totalLoanAmount * monthlyInterestRate * totalLoanInterestRate) /
        (totalLoanInterestRate - 1);
    resultObj.pi = resultPI;
    //  set up  taxes  the value of 
    if (!isNaN(data.propertyTaxRate) || !!data.propertyTaxRate) {
        var resultTaxes =
            data.downPaymentRatio == 0 && data.total
                ? ((data.total * data.propertyTaxRate) / 100 / 12).toFixed(0)
                : (
                    (((data.downPaymentValue * 100) / data.downPaymentRatio) *
                        data.propertyTaxRate) /
                    100 /
                    12
                ).toFixed(0);
        resultObj['taxes'] = resultTaxes;
    } else {
        resultObj['taxes'] = 0;
    }
    //  set up   insurance  field value 
    if (!isNaN(data.homeInsurance) || !!data.homeInsurance) {
        var resultInsurance = (data.homeInsurance / 12).toFixed(0);
        resultObj['homeInsurance'] = resultInsurance;
    } else {
        // clear results 
        resultObj['homeInsurance'] = 0;
    }

    if (!isNaN(data.hoaFee) || !!data.hoaFee) {
        var hoaFee = data.hoaFee;
        resultObj['hoaFee'] = hoaFee;
    } else {
        resultObj['hoaFee'] = 0;
    }
    if (!isNaN(data.chimeMaintenanceFee) || !!data.chimeMaintenanceFee) {
        var chimeMaintenanceFee = data.chimeMaintenanceFee;
        resultObj['chimeMaintenanceFee'] = chimeMaintenanceFee;
    } else {
        resultObj['chimeMaintenanceFee'] = 0;
    }
    return resultObj;
}

export default calculateResult;

export function getSplineData(
    homePrice = 300000,
    downPayment = 60000,
    pi = 1119,
    loanTerm = 30,
    interestRate = 0.03803
) {
    let interest = [0],
        principal = [0],
        remaining = [homePrice - downPayment];
    for (let i = 1; i < loanTerm * 12 + 1; i++) {
        interest.push((remaining[i - 1] * interestRate) / 12 + interest[i - 1]);
        principal.push(pi - interest[i] + interest[i - 1] + principal[i - 1]);
        remaining.push(homePrice - downPayment - principal[i]);
    }

    //  Round the calculation result 
    for (let i = 0, len = interest.length; i < len; i++) {
        interest[i] = Math.round(interest[i]);
        principal[i] = Math.round(principal[i]);
        remaining[i] = Math.round(remaining[i]);
    }
    return [interest, principal, remaining];
}

/** Mortgage based on income  */
export function calcuFromIncome(data) {
    var resultObj = {};
    for (var key in data) {
        if (typeof data[key] == 'string') {
            data[key] = parseFloat(data[key].replace(/,/g, '')); 
        }
    }
    let total = 0;
    let b =
        ((data.interestRate / 1200) *
            Math.pow(data.interestRate / 1200 + 1, data.loanTerm * 12)) /
        (Math.pow(data.interestRate / 1200 + 1, data.loanTerm * 12) - 1);

    let fenzi =
        data.debtRatio * (data.annualIncome / 12) -
        data.otherMonthlyDebts -
        data.homeInsurance / 12 -
        data.hoaFee +
        b * data.downPaymentValue;
    let fenmu = data.propertyTaxRate / 1200 + b;
    total = (fenzi / fenmu).toFixed(0);
    resultObj['total'] = total;
    //  monthly interest rate 
    var monthlyInterestRate = data.interestRate / 1200; //l
    //  total loan interest rate  = （1+l）^( total number of months )
    var totalLoanInterestRate = Math.pow(
        1 + monthlyInterestRate,
        data.loanTerm * 12
    ); //0
    //  total loan amount 
    var totalLoanAmount = total - data.downPaymentValue; //e
    //  monthly bank loan repayment 
    var resultPI = (
        (totalLoanAmount * monthlyInterestRate * totalLoanInterestRate) /
        (totalLoanInterestRate - 1)
    ).toFixed(0);
    resultObj['pi'] = resultPI;
    //  set up  taxes  the value of 
    if (isNaN(resultPI)) {
        resultObj['pi'] = 0;
    }
    if (!isNaN(data.propertyTaxRate) || !!data.propertyTaxRate) {
        var resultTaxes = ((total * data.propertyTaxRate) / 100 / 12).toFixed(
            0
        );
        resultObj['taxes'] = resultTaxes;
    } else {
        resultObj['taxes'] = 0;
    }
    //  set up   insurance  field value 
    if (!isNaN(data.homeInsurance || !!data.homeInsurance)) {
        var resultInsurance = (data.homeInsurance / 12).toFixed(0);
        resultObj['homeInsurance'] = resultInsurance;
    } else {
        // clear results 
        resultObj['homeInsurance'] = 0;
    }
    // set up  Fees
    if (!isNaN(data.hoaFee) || !!data.hoaFee) {
        var resultFees = data.hoaFee;
        resultObj['hoaFee'] = resultFees;
    } else {
        resultObj['hoaFee'] = 0;
    }
    return resultObj;
}
